import { Id } from "@planzone/dto";
import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return (projectId: Id) =>
    present(
      repository.getProject(projectId).catch(() => Promise.reject(projectId)),
    );
}

export type { Interactor };

export { createInteractor };
